module.exports = [
	"advice:article",
	"advice:category",
	"advice:guide",
	"author:author",
	"dotrealtor:adp",
	"finance:calculator:affordability",
	"finance:calculator:mortgage",
	"finance:calculator:refinance-calculator",
	"finance:calculators:buy-vs-rent-calculator",
	"finance:hub:home-loan",
	"finance:hub:home-loan:estimate-home-value",
	"finance:hub:home-loan:get-pre-approved",
	"finance:hub:veterans",
	"finance:landing",
	"finance:landing:75-for-75-winnerannounce",
	"finance:landing:VU-Sweeps5-100K-Winner",
	"finance:landing:VU-Sweeps6-75k",
	"finance:landing:VU-Sweeps6-75k-Closed",
	"finance:landing:VU-Sweeps7-100k",
	"finance:landing:home-holidays-sweepstakes-winnerannounce",
	"finance:landing:home-loan:get-pre-approved",
	"finance:landing:independence-day-giveaway-winnerannounce",
	"finance:loan_home_get_pre_approved:bankruptcy",
	"finance:loan_home_get_pre_approved:credit_rating",
	"finance:loan_home_get_pre_approved:credit_services",
	"finance:loan_home_get_pre_approved:current_address",
	"finance:loan_home_get_pre_approved:down_payment_pct",
	"finance:loan_home_get_pre_approved:email",
	"finance:loan_home_get_pre_approved:employment-status",
	"finance:loan_home_get_pre_approved:error_page",
	"finance:loan_home_get_pre_approved:first-time-homebuyer",
	"finance:loan_home_get_pre_approved:household-income",
	"finance:loan_home_get_pre_approved:land",
	"finance:loan_home_get_pre_approved:landing",
	"finance:loan_home_get_pre_approved:military",
	"finance:loan_home_get_pre_approved:military_branch",
	"finance:loan_home_get_pre_approved:name",
	"finance:loan_home_get_pre_approved:phone",
	"finance:loan_home_get_pre_approved:property-type",
	"finance:loan_home_get_pre_approved:property_location",
	"finance:loan_home_get_pre_approved:property_use",
	"finance:loan_home_get_pre_approved:property_value",
	"finance:loan_home_get_pre_approved:purchase_status",
	"finance:loan_home_get_pre_approved:real-estate-agent",
	"finance:loan_home_get_pre_approved:refi_balance",
	"finance:loan_home_get_pre_approved:refi_borrow",
	"finance:loan_home_get_pre_approved:refi_rate",
	"finance:loan_home_get_pre_approved:refi_second_mortgage",
	"finance:loan_home_get_pre_approved:state-unavailable",
	"finance:loan_home_get_pre_approved:submit_fail",
	"finance:loan_home_get_pre_approved:submit_success",
	"finance:rate_table_purchase",
	"finance:rate_table_refinance",
	"global:captcha:",
	"global:errors",
	"global:errors:404",
	"global:errors:408",
	"global:errors:500",
	"global:fraud-alert:",
	"global:ip-blocked:",
	"global:sitemap:",
	"homes::ldp-quickview:active:for_rent",
	"homes::ldp-quickview:active:for_sale:foreclosure",
	"homes::ldp-quickview:active:new_community",
	"homes::ldp-quickview:active:new_community:new_plan",
	"homes::ldp-quickview:inactive:for_rent",
	"homes::ldp-quickview:inactive:for_sale",
	"homes::ldp-quickview:inactive:not_for_sale:off_market",
	"homes::ldp-quickview:inactive:not_for_sale:recently_sold",
	"homes:bdp",
	"homes:browse:for_sale",
	"homes:browse:foreclosure",
	"homes:browse:new_community",
	"homes:browse:new_construction",
	"homes:browse:not_for_sale",
	"homes:browse:recently_sold",
	"homes:hp",
	"homes:landing:for_sale",
	"homes:landing:new_community",
	"homes:landing:not_for_sale",
	"homes:landing:recently_sold",
	"homes:ldp-quickview:active:for_sale",
	"homes:ldp:active:for_rent",
	"homes:ldp:active:for_sale",
	"homes:ldp:active:for_sale:foreclosure",
	"homes:ldp:active:new_community",
	"homes:ldp:active:new_community:new_plan",
	"homes:ldp:inactive:for_rent",
	"homes:ldp:inactive:for_sale",
	"homes:ldp:inactive:not_for_sale:foreclosure",
	"homes:ldp:inactive:not_for_sale:off_market",
	"homes:ldp:inactive:not_for_sale:recently_sold",
	"homes:seller:summary",
	"homes:srp-list:for_rent",
	"homes:srp-list:for_sale",
	"homes:srp-list:for_sale:foreclosure",
	"homes:srp-list:for_sale:new_plan",
	"homes:srp-list:new_community",
	"homes:srp-list:not_for_sale:recently_sold",
	"homes:srp-list:recently_sold:recently_sold",
	"homes:srp-map:for_rent",
	"homes:srp-map:for_sale",
	"homes:srp-map:for_sale:foreclosure",
	"homes:srp-map:for_sale:new_plan",
	"homes:srp-map:new_community",
	"homes:srp-map:not_for_sale",
	"homes:srp-map:not_for_sale:recently_sold",
	"homes:srp-map:recently_sold:recently_sold",
	"news:article",
	"news:category",
	"news:home",
	"realtors:dp:agent",
	"realtors:dp:office",
	"realtors:dp:team",
	"realtors:hp",
	"realtors:srp",
	"rentals::ldp-quickview:active:for_rent",
	"rentals:browse:for_rent",
	"rentals:landing:for_rent",
	"rentals:ldp:active:for_rent",
	"rentals:srp-list:for_rent",
	"rentals:srp-map:for_rent",
	"syndicated:adp",
	"tag:tag",
	"videos:video-browse",
	"videos:video-details",
	"videos:video-hub"
];


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/constants/legacy_page_names_whitelist.json
// module id = 769
// module chunks = 48 49 50